import * as React from "react";

const BookInfoPage: React.FC = () => (
  <div>
    참고한 책에 대해 표지 이미지와 간략한 정보를 소개하고,
    페이지에 내용은 이 책에서 비롯된 내용임을 알려주는 페이지입니다.

    우와 정말 데단해~
  </div>
);

export default BookInfoPage;
